import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Container,
  Typography,
  IconButton,
  Drawer,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import MastersoftLogo from "../../images/mastersoft_lg.png";
import { useTranslation } from "react-i18next";

export default function Header() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const navButtonStyle = (active) => ({
    color: "white",
    border: active ? "2px solid white" : "2px solid transparent",
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      color: "#ffff",
      border: "2px ridge #ffff",
      backgroundColor: "transparent",
      transform: "scale(1.05)",
    },
  });

  return (
    <AppBar position="sticky" sx={{ backgroundColor: "#76959c" }}>
      <Container maxWidth="lg">
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          {/* Sol: Logo */}
          <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
            <Link to="/">
              <img
                src={MastersoftLogo}
                alt="Mastersoft Logo"
                style={{ height: "50px", borderRadius: "5px" }}
              />
            </Link>
          </Box>

          {/* Orta: Menü */}
          <Box
            sx={{
              display: isMobile ? "none" : "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: 2,
              gap: 4,
            }}
          >
            <Button component={Link} to="/about" sx={navButtonStyle(isActive("/about"))}>
              {t("about")}
            </Button>
            <Button component={Link} to="/services" sx={navButtonStyle(isActive("/services"))}>
              {t("services")}
            </Button>
            <Button component={Link} to="/products" sx={navButtonStyle(isActive("/products"))}>
              {t("products")}
            </Button>
            <Button component={Link} to="/contact" sx={navButtonStyle(isActive("/contact"))}>
              {t("contact")}
            </Button>
          </Box>

          {/* Sağ: Dil ve Menü */}
          <Box sx={{ display: "flex", alignItems: "center", flex: 1, justifyContent: "flex-end" }}>
            {/* Dil Seçimi */}
            <Box sx={{ display: "flex", gap: 1, mr: 1 }}>
              
              <IconButton onClick={() => changeLanguage("tr")}>
                <Typography variant="p" fontSize="1.1rem" color="white" gutterBottom={false}>
                    TR
                </Typography>  
                &nbsp;       
                <img src="/flags/tr.png" alt="Türkçe" style={{ width: 24, height: 24 }} />
              </IconButton>
              
              <IconButton onClick={() => changeLanguage("en")}>
                <Typography variant="p" fontSize="1.1rem" color="white" gutterBottom={false}>
                    EN
                </Typography>
                &nbsp;
                <img src="/flags/en.png" alt="English" style={{ width: 24, height: 24 }} />
              </IconButton>
            </Box>

            {/* Mobil Menü Butonu */}
            {isMobile && (
              <IconButton edge="end" color="inherit" onClick={toggleMobileMenu}>
                <MenuIcon />
              </IconButton>
            )}
          </Box>
        </Toolbar>

        {/* Mobil Menü Drawer */}
        <Drawer anchor="right" open={mobileMenuOpen} onClose={toggleMobileMenu}>
            <Box sx={{ width: 250, p: 2 }}>
                {[
                { path: "/about", label: t("about") },
                { path: "/services", label: t("services") },
                { path: "/products", label: t("products") },
                { path: "/contact", label: t("contact") },
                ].map((item) => (
                <Button
                    key={item.path}
                    component={Link}
                    to={item.path}
                    // onClick={() => {
                    //     toggleMobileMenu(); // Önce menüyü kapat
                    //     setTimeout(() => {
                    //       navigate(item.path); // Sonra route değiştir
                    //     }, 300); // Menü kapanmadan önce yönlendirme olmasın
                    // }}
                    // onClick={toggleMobileMenu}
                    onClick={() => {
                        window.scrollTo(0, 0); // Sayfayı yukarı kaydır
                        //  toggleMobileMenu();    // Menü kapansın
                        navigate(item.path); // Sayfa yönlendirme
                        setTimeout(() => {
                          window.scrollTo(0, 0); // Yönlendirme sonrası scroll
                        }, 100); // küçük bir gecikme gerekiyor
                        toggleMobileMenu(); // menüyü kapat
                    }}
                    sx={{
                    display: "block",
                    mb: 2,
                    width: "100%",
                    justifyContent: "flex-start",
                    border: isActive(item.path) ? "2px solid #76959c" : "none",
                    borderRadius: "6px",
                    backgroundColor: isActive(item.path) ? "#f0f0f0" : "transparent",
                    color: "#000",
                    textTransform: "none",
                    }}
                >
                    {item.label}
                </Button>
                ))}
            </Box>
        </Drawer>

      </Container>
    </AppBar>
  );
}
